import Services from "../../services/Services";
const services = new Services(null) as any;

// toast actions
import {
  dismiss,
  update,
  error,
  message,
  warning,
  success,
  info,
} from "react-toastify-redux";

const GET_ASSESSMENTS = "schoolSF/getAssessments";
const GET_YEAR_GROUPS_DEPARTMENTS = "schoolSF/getYearGroupsDepartments";
const GET_DEPARTMENTS = "schoolSF/getDepartments";
const GET_ASSESSMENT_SEARCH_FILTERS = "schoolSF/getAssessmentSearchFilters";
const UPDATE_MULTIPLE_VALS = "schoolSF/updateMultipleValues";
const GET_STUDENTS_FILTERED = "schoolSF/getStudentsFiltered";

const INITIAL_STATE = {
  departments: [],
  yearGroups: [],
  assessments: [],
  loaded: false,
  filteredLoaded: false,
  questionGroups: [],
  selectedAssessment: null,
  selectedGroup: 0,
  filteredStudents: [],
  currentDepartment: "",
  currentYearGroup: "",
  noFilters: false,
  guidesRead: true,
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_ASSESSMENTS:
      return {
        ...state,
        ...payload,
      };

    case GET_YEAR_GROUPS_DEPARTMENTS:
      return {
        ...state,
        departments: payload.departments,
        yearGroups: payload.yearGroups,
      };

    case GET_DEPARTMENTS:
      return {
        ...state,
        departments: payload,
      };

    case GET_ASSESSMENT_SEARCH_FILTERS: {
      return {
        ...state,
        ...payload,
      };
    }

    case GET_STUDENTS_FILTERED: {
      return {
        ...state,
        ...payload,
      };
    }

    case UPDATE_MULTIPLE_VALS: {
      return {
        ...state,
        ...payload,
      };
    }

    default:
      return state;
  }
};

export const getAssessments = (userId) => async (dispatch) => {
  const assessmentsRes =
    await services.institutionsAPI.getInstitutionsAssessments(userId);
  if (assessmentsRes.ok) {
    dispatch({
      type: GET_ASSESSMENTS,
      payload: {
        assessments: assessmentsRes.data.assessments,
        loaded: true,
      },
    });
  } else {
    dispatch(error("Unable to load your assessments"));
  }
};

export const getYearGroupsDepartments = (currentUserID) => async (dispatch) => {
  const [yrGrpRes, departmentsRes] = await Promise.all([
    services.institutionsAPI.getInstitutionYearGroups(currentUserID),
    services.institutionsAPI.getInstitutionDepartments(currentUserID),
  ]);
  if (yrGrpRes.ok) {
    dispatch({
      type: GET_YEAR_GROUPS_DEPARTMENTS,
      payload: {
        yearGroups: yrGrpRes.data.year_groups,
        departments: departmentsRes.data.departments,
        loaded: true,
      },
    });
  } else {
    dispatch(error("Unable to load your year groups/departments"));
  }
};

export const getAssessmentSearchFilters =
  (currentUserID, selectedAssessment, query) => async (dispatch) => {
    const payloadRes =
      await services.institutionsAPI.getInstitutionAssessmentSearchFilters(
        currentUserID,
        selectedAssessment,
        query
      );

    if (payloadRes.ok) {
      const questionGroups = payloadRes.data.filters;
      if (questionGroups.length < 1) {
        dispatch({
          type: UPDATE_MULTIPLE_VALS,
          payload: { noFilters: true, loaded: true },
        });
        return;
      }
      const groupTotal = questionGroups.reduce((grp1, grpNext) => {
        return { NumStudents: grp1.NumStudents + grpNext.NumStudents };
      }); // reducer func to calculate total number of students in returned assessment
      const assessmentStudentTotal = groupTotal.NumStudents;

      const tourStatus = localStorage.getItem(
        `${services.currentUsername}DataCenterTour`
      );
      let guidesRead = true;
      if (tourStatus === null) {
        guidesRead = false;
      }

      dispatch({
        type: GET_ASSESSMENT_SEARCH_FILTERS,
        payload: {
          questionGroups,
          selectedAssessment,
          filteredStudents: [],
          assessmentStudentTotal,
          loaded: true,
          guidesRead,
        },
      });
    }
  };

export const getStudentsFiltered =
  (currentUserID, selectedGroup, selectedAssessment) => async (dispatch) => {
    const payloadRes =
      await services.institutionsAPI.getInstitutionAssessmentStudentSearchFiltered(
        currentUserID,
        selectedGroup,
        selectedAssessment
      );

    if (payloadRes.ok) {
      const filteredStudents = payloadRes.data.results;
      dispatch({
        type: GET_STUDENTS_FILTERED,
        payload: { filteredStudents, loaded: true },
      });
    }
  };

export const updateMultipleVals = (valuesObj) => async (dispatch) => {
  dispatch({ type: UPDATE_MULTIPLE_VALS, payload: valuesObj });
};



// WEBPACK FOOTER //
// ./src/redux/ducks/schoolSearchFilters.ts